export default "__VITE_ASSET__6YLEjw67__"